module.exports = __webpack_public_path__ + "img/14.b14891d8.png";